export const SPACING_UNIT = 8;
export const SPACING_REGULAR = 16;
export const SPACING_SECTION = 24;
export const SPACING_LARGE = 32;
export const SPACING_HUGE = 40;
export const PADDING_SPACING = 36;
export const PADDING_SP_SPACING = 16;
